import { ifNotNull } from '~/utils/misc';

interface RecordClass<T> {
  new (args: T);
}

export function createRecordIfNotNull<A, R extends RecordClass<A>>(
  maybeNull: A,
  Record: R
): InstanceType<R> | null {
  return ifNotNull(maybeNull, new Record(maybeNull));
}
